import React, { useContext, useEffect } from 'react'
import { Modal, Card, Box, Typography, CardHeader, CardContent, Grid } from '@mui/material'
import { Alerts, IconBtn, InputButton, Loading, SearchAlert } from '../../Simple'
import { MdOutlineContentCopy } from 'react-icons/md'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import CloseIcon from '@mui/icons-material/Close'
import moment from 'moment'
import copy from 'copy-to-clipboard'

export default function Cupons({ open, onClose, width = 500, height = 'auto' }) {
  const { sttPg, actionsCtxEmps, loads } = useContext(EmpresasContext)

  useEffect(() => {
    document.title = 'Cupons | Agendei Quadras'
    actionsCtxEmps.BuscarCuponsAtivosEmpresa()
  }, [sttPg.empresa.idempresa])

  function CompCupom({ cupom }) {
    function handleCopy() {
      const sucesso = copy(cupom.codigo)
      if (sucesso) {
        Alerts.swal('success', 'Cupom copiado', 'O cupom foi copiado para a área de transferência')
      } else {
        Alerts.swal(
          'warning',
          'Aviso',
          'Parece que ocorreu um erro ao copiar o cupom, por favor, tente escrever o código manualmente',
        )
      }
    }

    return (
      <Card
        sx={{
          marginBottom: 1,
          border: '2px dashed #f5f5f5',
          overflow: 'visible',
          boxShadow: 'none',
          borderRadius: '12px',
          padding: '0px',
        }}
      >
        <Grid container spacing={0} sx={{ borderBottom: '2px dashed #f5f5f5' }}>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'row',
            }}
          >
            <InputButton
              fullWidth
              variant='text'
              endIcon={<MdOutlineContentCopy size={25} />}
              onClick={() => {
                handleCopy()
              }}
              sx={{ fontSize: '1.2rem', fontFamily: 'jost-mediun', margin: '10px 0px 5px 0px' }}
            >
              {cupom.codigo}
            </InputButton>
          </Grid>
          <Grid item xs={12} sx={{ marginBottom: '5px' }}>
            <Typography variant='h6' align='center' color='success.green' fontWeight='bold'>
              R$ {parseFloat(cupom.valorDesconto).toFixed(2).replace('.', ',')} OFF
            </Typography>
            <Typography variant='body2' align='center'>
              {moment(cupom.dataFim).diff(moment(), 'days') > 0
                ? `Expira ${moment(cupom.dataFim).startOf('day').fromNow()}`
                : `Expirado ${moment(cupom.dataFim).startOf('day').fromNow()}`}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={0} sx={{ padding: '10px' }}>
          <Grid item xs={12} padding={'0px 10px'}>
            <Typography variant='body2'>
              {cupom.descricao.split('\r\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </Typography>
          </Grid>
          <Grid container spacing={0} sx={stMob.containValues}>
            <Grid item xs={6}>
              <Typography variant='body2' sx={stMob.textValues}>
                Valor mínimo:
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body2' align='right' sx={stMob.textValues}>
                R$ {parseFloat(cupom.valorMinimoPedido).toFixed(2).replace('.', ',')}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body2' sx={stMob.textValues}>
                Tipo:{' '}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body2' align='right' sx={stMob.textValues}>
                {cupom.aplicarAvulso ? 'Avulso' : 'Fixo'}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body2' sx={stMob.textValues}>
                Pagamento:{' '}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body2' align='right' sx={stMob.textValues}>
                {cupom.habilitadoPagamentoOnline && cupom.habilitadoPagamentoLocal
                  ? 'Local e Online'
                  : cupom.habilitadoPagamentoOnline
                    ? 'Online'
                    : 'Local'}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body2' sx={stMob.textValues}>
                Limite de uso:{' '}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant='body2' align='right' sx={stMob.textValues}>
                {cupom.limiteUsoPorUsuario === 1
                  ? 'Uma única vez'
                  : `${cupom.limiteUsoPorUsuario} vezes`}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    )
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Card
        sx={{
          width: width,
          bgcolor: 'background.paper',
          height: height,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          borderRadius: 3,
          maxHeight: '90vh',
        }}
      >
        <CardHeader
          position='sticky'
          top={0}
          action={<IconBtn onClick={() => onClose()} Icon={CloseIcon} title='Fechar' />}
          title={
            <Typography variant='h5' fontWeight='bold'>
              Cupons disponíveis
            </Typography>
          }
        />

        <CardContent
          sx={{
            overflowY: 'auto',
          }}
        >
          {loads.cupons ? (
            <Loading text={'Carregando os cupons disponíveis...'} />
          ) : (
            <>
              {/* Componente de Cupons */}
              {sttPg.cupons?.length === 0 ? (
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                    width: '100%',
                    padding: '10px 20px',
                  }}
                >
                  <SearchAlert text={'Nenhum cupom disponível para este centro esportivo'} />
                  <InputButton
                    fullWidth
                    variant='contained'
                    onClick={() => onClose()}
                    sx={{ marginTop: 2 }}
                  >
                    Entendi
                  </InputButton>
                </Box>
              ) : (
                sttPg.cupons
                  ?.filter(cupom => cupom.isAtivo)
                  .map((cupom, index) => (
                    <React.Fragment key={index}>
                      <CompCupom cupom={cupom} />
                    </React.Fragment>
                  ))
              )}
              <InputButton
                fullWidth
                variant='contained'
                onClick={() => onClose()}
                sx={{ marginTop: '3px' }}
              >
                Entendi
              </InputButton>
            </>
          )}
        </CardContent>
      </Card>
    </Modal>
  )
}

const stMob = {
  containValues: {
    padding: '10px',
    backgroundColor: '#f5f5f5',
    borderRadius: '12px',
  },
  textValues: {
    fontFamily: 'jost-mediun',
  },
}
